import './PermissionLegend.scss';

import PermissionLegend from './PermissionLegend';

export default PermissionLegend;
